import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import {
  //DesktopMenu,
  //DesktopMenuItem,
  HeaderContainer,
  Logo,
  LogoContainer,
  ToolbarContainer,
} from "./Header.styled";
import { breakpoints } from "../../constants/breakpoints";

import LogoLg from "../../assets/logo.png";
import LogoMd from "../../assets/logo.png";
import LogoSm from "../../assets/logo-80.png";
import useDevice from "../../hooks/useDevice";
//import { useLocation } from "react-router-dom";
import HeaderMenu from "./HeaderMenu/HeaderMenu";
import SocialNetworks from "./SocialNetworks/SocialNetworks";
import MobileDrawer from "./HeaderMenuMobile/MobileDrawer";
import { PAGES } from "../../constants/pages";

interface HeaderProps {
  title?: string;
}

const Header: React.FC<HeaderProps> = () => {
  // const { pathname } = useLocation();
  const { isTablet, isDesktop, isMobile } = useDevice(); //, isTablet, isDesktop, isMobile

  return (
    <HeaderContainer position={"relative"}>
      <Container maxWidth="xl">
        <ToolbarContainer disableGutters>
          <LogoContainer to={PAGES.BASE.route ?? "/"}>
            <Logo>
              <source
                media={`(min-width:${breakpoints.tablet}px)`}
                srcSet={LogoLg}
                height={89}
              />
              <source
                media={`(min-width:${breakpoints.mobile}px)`}
                srcSet={LogoMd}
                height={60}
              />
              <img src={LogoSm} alt="BP Consulting Logo" />
            </Logo>
          </LogoContainer>
          {isMobile && <MobileDrawer />}
          {(isDesktop || isTablet) && <HeaderMenu />}
          {isDesktop && (
            <Box sx={{ flexGrow: 0 }}>
              <SocialNetworks />
            </Box>
          )}
        </ToolbarContainer>
      </Container>
    </HeaderContainer>
  );
};

export default Header;
